import { render, staticRenderFns } from "./ScraperPagesTable.vue?vue&type=template&id=1904f3da&"
import script from "./ScraperPagesTable.vue?vue&type=script&lang=js&"
export * from "./ScraperPagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports